import React, { useState, useEffect } from "react";
import { API, graphqlOperation, Auth } from "aws-amplify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.svg";
import { listCompanyProfiles, listProfileVisits } from "../../graphql/queries";
import { listCandidateProfiles } from "../../graphql/queries";
import { IoIosNotifications } from "react-icons/io";
import profilephoto from "../../assets/profile.png";
import { MdCancel } from "react-icons/md";
import { updateProfileVisit } from "../../graphql/mutations";

const ProfileModal = ({
  isOpen,
  onClose,
  onHome,
  onLogoutClick,
  onAdminaddcontext,
  onProfileClickUpdate,
}) => {
  const candidateProfileEmailID = localStorage.getItem(
    "candidateProfileEmailID"
  );
  const [iscompany, setIscompany] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [candidateProfileExists, setCandidateProfileExists] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let nextToken = null;
        let userProfileList = [];
        do {
          const CompanyResponse = await API.graphql(
            graphqlOperation(listCompanyProfiles, {
              filter: { email: { eq: candidateProfileEmailID } },
              limit: 100,
              nextToken: nextToken,
            })
          );

          setIscompany(CompanyResponse.data.listCompanyProfiles.items[0]);
          userProfileList.push(
            ...CompanyResponse.data.listCompanyProfiles.items
          );
          nextToken = CompanyResponse.data.listCompanyProfiles.nextToken;
        } while (nextToken);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    // checking candidate profile id
    async function checkcandidateProfile() {
      setIsLoading(true);
      try {
        let nextToken = null;
        let candidateProfile = null;
        const userInfo = await Auth.currentAuthenticatedUser();
        const userEmail = userInfo.attributes.email.toLowerCase();

        do {
          const candidateProfileData = await API.graphql(
            graphqlOperation(listCandidateProfiles, {
              filter: {
                email: {
                  eq: userEmail,
                },
              },
              limit: 100,
              nextToken: nextToken,
            })
          );

          const items = candidateProfileData.data.listCandidateProfiles.items;
          if (items.length > 0) {
            candidateProfile = items[0];
            setCandidateProfileExists(true);
            localStorage.setItem("candidateProfileId", candidateProfile.id);
            localStorage.setItem(
              "candidateProfile",
              JSON.stringify(candidateProfile)
            );
            break;
          } else {
            nextToken =
              candidateProfileData.data.listCandidateProfiles.nextToken;
          }
        } while (nextToken);

        if (!candidateProfile) {
          console.log("No profile found for this candidate ID.");
          setCandidateProfileExists(false);
        }
      } catch (error) {
        console.error("Error fetching candidate profile", error);
        setCandidateProfileExists(false);
      } finally {
        setIsLoading(false);
      }
    }

    checkcandidateProfile();
  }, []);

  const handleLogout = () => {
    const keysToRemove = [
      "candidateProfileEmailID",
      "candidateProfileAuthID",
      "candidateProfileId",
      "candidateProfile",
      "CompanyProfileID",
      "CompanyEmailID",
      "CompanyProfile",
      "RecentJDIdAfterJDupload"
    ];
    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
    });
    onLogoutClick();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/40 z-40"
        onClick={onClose}
      />
      
      {/* Dropdown Menu - Compact Dark Theme */}
      <div className="absolute right-0 top-full mt-1 w-64 bg-gray-900 rounded-lg shadow-xl border border-gray-700/50 z-50 overflow-hidden animate-fadeIn">
        {/* User Info Section */}
        <div className="px-3 py-2.5 bg-gradient-to-r from-purple-900/80 to-indigo-900/80 border-b border-gray-700/50">
          <p className="text-gray-400 text-[10px] uppercase tracking-wider mb-0.5">Signed in as</p>
          <p className="text-white text-xs font-medium break-all leading-snug m-0">
            {candidateProfileEmailID}
          </p>
        </div>

        {/* Menu Items */}
        <div className="py-1">
          <button
            className="w-full px-3 py-2 text-left text-gray-200 hover:bg-gray-800 flex items-center gap-2.5 transition-colors text-sm"
            onClick={onHome}
          >
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            <span>Home</span>
          </button>

          {/* Loading state for profile button */}
          {isLoading ? (
            <div className="w-full px-3 py-2 flex items-center gap-2.5 text-sm">
              <div className="w-4 h-4 border-2 border-gray-600 border-t-purple-500 rounded-full animate-spin" />
              <span className="text-gray-400">Loading...</span>
            </div>
          ) : candidateProfileExists ? (
            <button
              className="w-full px-3 py-2 text-left text-gray-200 hover:bg-gray-800 flex items-center gap-2.5 transition-colors text-sm"
              onClick={onProfileClickUpdate}
            >
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span>Edit Profile</span>
            </button>
          ) : iscompany ? (
            <button className="w-full px-3 py-2 text-left text-gray-200 hover:bg-gray-800 flex items-center gap-2.5 transition-colors text-sm">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span>Company Profile</span>
            </button>
          ) : null}

          {candidateProfileEmailID === "getscreened@varahitechnologies.com" && (
            <button
              className="w-full px-3 py-2 text-left text-emerald-400 hover:bg-emerald-900/30 flex items-center gap-2.5 transition-colors text-sm"
              onClick={onAdminaddcontext}
            >
              <svg className="w-4 h-4 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Admin</span>
            </button>
          )}

          <div className="border-t border-gray-700/50 my-1" />

          <Link to={"/"} className="no-underline">
            <button
              className="w-full px-3 py-2 text-left text-red-400 hover:bg-red-900/30 flex items-center gap-2.5 transition-colors text-sm"
              onClick={handleLogout}
            >
              <svg className="w-4 h-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span>Sign Out</span>
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

function Header({ signOut }) {
  const [showEmail, setShowEmail] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [candidateEmail, setCandidateEmail] = useState("");
  const navigate = useNavigate();

  // view/seen code start

  const [profilevisits, setProfileVisits] = useState({});
  const [arrayofObjectProfile, setArrayofObjectProfile] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [sortedData, setSortedData] = useState([]);
  const [notificationIsNew, setNotificationIsNew] = useState(false);
  const [iscandidate, setIscandidate] = useState(false);

  const location = useLocation();

  // Check if we're on the /profileedit page
  const showmyskill = location.pathname === "/ShowMySkills";

  // view/seen code end

  useEffect(() => {
    const candidateProfileEmailID = localStorage.getItem(
      "candidateProfileEmailID"
    );
    setCandidateEmail(candidateProfileEmailID);
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const handleWindowResize = () => {
    if (window.innerWidth <= 500) {
      setShowEmail(false);
    } else {
      setShowEmail(true);
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    console.log("Modal toggled");
  };

  // seen/view Notication code start

  useEffect(() => {
    const visitedEmailfromlocal = localStorage.getItem(
      "candidateProfileEmailID"
    );

    const fetchViewandSeenData = async (visitedEmailfromlocal) => {
      const user = localStorage.getItem("candidateProfile");

      if (user) {
        setIscandidate(true);
      }

      let profileVisitItemsList = [];
      let currentNextToken = null;

      try {
        do {
          const response = await API.graphql(
            graphqlOperation(listProfileVisits, {
              // Updated query name to listProfileVisits
              filter: { visitedEmail: { eq: visitedEmailfromlocal } }, // Filter by visitedEmail
              // If you want to add a limit, uncomment the next line:
              // limit: 2500,
              nextToken: currentNextToken,
            })
          );

          // Ensure we're accessing the correct data structure
          const profileVisitData = response.data.listProfileVisits || {};
          const items = profileVisitData.items || [];

          // Set currentNextToken for pagination
          currentNextToken = profileVisitData.nextToken;

          // Append the fetched items to the list
          profileVisitItemsList = [...profileVisitItemsList, ...items];
        } while (currentNextToken);

        // Set state with the fetched profile visit data
        setProfileVisits(profileVisitItemsList[0]); // or adjust based on what you need
        setArrayofObjectProfile(profileVisitItemsList);

        // filter code start

        const currentDate = new Date(); // Current date and time
        const fifteenDaysAgo = new Date(currentDate);
        fifteenDaysAgo.setDate(currentDate.getDate() - 15); // Date 15 days ago

        // Filter and sort the profile visits
        const filteredSortedProfileVisits = profileVisitItemsList
          .filter((item) => {
            // Convert visitedTime to a Date object for comparison
            const visitedDate = new Date(item.visitedTime);
            // Filter by visits within the last 15 days
            return visitedDate >= fifteenDaysAgo && visitedDate <= currentDate;
          })
          .sort((a, b) => {
            // Sort by visitedTime in descending order (most recent first)
            return new Date(b.visitedTime) - new Date(a.visitedTime);
          });

        setSortedData(filteredSortedProfileVisits);

        if (filteredSortedProfileVisits.length === 0) {
          setNotificationIsNew(true);
        }

        if (
          filteredSortedProfileVisits.length > 0 &&
          filteredSortedProfileVisits
        ) {
          const { id, isViewed } = filteredSortedProfileVisits[0];

          if (isViewed === false) {
            setNotificationIsNew(false);
          }

          if (isViewed === true) {
            setNotificationIsNew(true);
          }
        }

        // filter code end
      } catch (error) {
        console.error("Error fetching Profile Visits:", error);
      }
    };

    fetchViewandSeenData(visitedEmailfromlocal);
  }, []);

  const notViewedItems = arrayofObjectProfile.filter((item) => !item.isViewed);

  const getTimeDifference = (visitedTime) => {
    const now = new Date();
    const visitedDate = new Date(visitedTime);
    const differenceInMs = now - visitedDate;

    const seconds = Math.floor(differenceInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return `${seconds}s ago`;
  };

  const changeShowModel = async () => {
    setShowPopup(!showPopup);

    if (sortedData && sortedData.length > 0) {
      const { id, isViewed } = sortedData[0];

      if (
        id !== undefined &&
        id !== null &&
        isViewed !== undefined &&
        isViewed !== null
      ) {
        if (isViewed === false && notificationIsNew === false) {
          try {
            setNotificationIsNew(true);

            const input = {
              id: id,
              isViewed: true,
            };

            const response = await API.graphql(
              graphqlOperation(updateProfileVisit, { input })
            );
          } catch (error) {
            console.log("updateProfileVisit", error);
          }
        }
      }
    }
  };

  // seen/view Notication code end
  // console.log("kkkkkkkkkkkkkkkk",sortedData)

  return (
    <header className="sticky top-0 z-30 w-full">
      {/* Main Header */}
      <div className="bg-gradient-to-r from-slate-900 via-purple-900 to-slate-900 shadow-lg">
        <div className="w-full px-4 sm:px-6">
          <div className="flex items-center justify-between h-16">
            {/* Logo - Far Left */}
            <Link to={"/"} className="flex-shrink-0">
              <img 
                src={logo} 
                alt="GetScreened" 
                className="h-10 w-auto hover:opacity-90 transition-opacity" 
              />
            </Link>

            {/* Right Section - Far Right */}
            <div className="flex items-center gap-2 sm:gap-4">
              {/* Notifications */}
              {iscandidate && !showmyskill && (
                <button
                  onClick={changeShowModel}
                  className="relative p-2 rounded-full hover:bg-white/10 transition-colors"
                  aria-label="Notifications"
                >
                  <IoIosNotifications className="text-white text-2xl" />
                  {!notificationIsNew && (
                    <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full ring-2 ring-slate-900" />
                  )}
                </button>
              )}

              {/* User Email (desktop only) */}
              {showEmail && (
                <span className="hidden sm:block text-white/80 text-sm max-w-[200px] truncate">
                  {candidateEmail}
                </span>
              )}

              {/* Profile Menu */}
              <div className="relative">
                <button
                  onClick={toggleModal}
                  className="flex items-center gap-2 p-1.5 rounded-full hover:bg-white/10 transition-colors"
                  aria-label="User menu"
                >
                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center shadow-inner">
                    <FontAwesomeIcon
                      icon={faUserCircle}
                      className="text-white text-lg"
                    />
                  </div>
                  <svg 
                    className={`hidden sm:block w-4 h-4 text-white/70 transition-transform ${isModalOpen ? 'rotate-180' : ''}`} 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {isModalOpen && (
                  <ProfileModal
                    isOpen={isModalOpen}
                    onClose={toggleModal}
                    onHome={() => {
                      navigate("/CandidateSchedule");
                    }}
                    onProfileClickUpdate={() => {
                      navigate("/EditCandidateProfileReg");
                    }}
                    onAdminaddcontext={() => {
                      navigate("/AdminAddcontext");
                    }}
                    onLogoutClick={signOut}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notifications Panel */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50">
          <div 
            className="absolute inset-0"
            onClick={() => setShowPopup(false)}
          />
          <div className="absolute right-4 top-20 w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden animate-slideIn">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-indigo-600 to-purple-600">
              <h3 className="text-lg font-semibold text-white m-0">
                Recent Visitors
              </h3>
              <button
                onClick={() => setShowPopup(false)}
                className="p-1 rounded-full hover:bg-white/20 transition-colors"
              >
                <MdCancel className="text-white text-xl" />
              </button>
            </div>

            {/* Content */}
            <div className="max-h-[60vh] overflow-y-auto">
              {sortedData.length > 0 ? (
                <ul className="divide-y divide-gray-100 m-0 p-0 list-none">
                  {sortedData
                    .sort((a, b) => new Date(b.visitedTime) - new Date(a.visitedTime))
                    .map((item, index) => {
                      let dataObject;
                      try {
                        dataObject = item.visitorProfile
                          ? JSON.parse(item.visitorProfile)
                          : {};
                      } catch (error) {
                        console.error("Error parsing visitorProfile:", error);
                      }

                      const handleRedirect = () => {
                        const encodedEmail = encodeURIComponent(dataObject?.email || "");
                        const shareableURL = `${window.location.origin}/ShowMySkills?email=${encodedEmail}`;
                        window.open(shareableURL, "_blank");
                      };

                      return (
                        <li
                          key={index}
                          onClick={handleRedirect}
                          className="flex items-center gap-3 px-5 py-4 hover:bg-gray-50 cursor-pointer transition-colors"
                        >
                          <img
                            src={
                              dataObject?.photoURL?.includes("staging")
                                ? profilephoto
                                : dataObject?.photoURL || profilephoto
                            }
                            alt=""
                            className="w-10 h-10 rounded-full object-cover ring-2 ring-gray-100"
                          />
                          <div className="flex-1 min-w-0">
                            <p className="text-sm text-gray-900 m-0">
                              <span className="font-semibold">
                                {dataObject?.fullName || dataObject?.companyName || "Someone"}
                              </span>
                              {" "}viewed your profile
                            </p>
                            <p className="text-xs text-gray-500 mt-0.5 m-0">
                              {getTimeDifference(item.visitedTime)}
                            </p>
                          </div>
                          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                          </svg>
                        </li>
                      );
                    })}
                </ul>
              ) : (
                <div className="py-12 text-center">
                  <svg className="w-16 h-16 mx-auto text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <p className="mt-4 text-gray-500">No profile visitors yet</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default withAuthenticator(Header);
